import { Component, OnInit, OnChanges, SimpleChanges, DoCheck, Input, Output, EventEmitter } from '@angular/core';
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { CookieService } from 'ngx-cookie-service';
import { FireService } from 'src/service/fire.service';

@Component({
  selector: "app-camera-controller",
  templateUrl: "./camera-controller.component.html",
  styleUrls: ["./camera-controller.component.css"],
})
export class CameraControllerComponent implements OnChanges, DoCheck {
  @Input() siteUri: string;
  @Input() simple: boolean = false;

  ptzCommands: string = "";
  @Input() ptzDirection: number = 0;
  @Input() ptzElevation: number = 0;
  @Input() ptzZoom: number = 1;
  @Output() ptzDirectionChanged = new EventEmitter<number>();
  @Output() ptzElevationChanged = new EventEmitter<number>();
  @Output() ptzZoomChanged = new EventEmitter<number>();
  
  history: number = 50;
  from: string;
  to: string;
  public c: any;  

  public rangeLimiter: any;

  private colours: string[];

  constructor(
    public cmd: CommandService,
    public fire: FireService,
    public toasterService: ToastrService,
    public app: ApplicationConfigService,
    public cookieService: CookieService
    ){
      
  }

  widgetBeforeInit() {}

  widgetAfterInit() {
    this.loadPtz();
  }

  public isNaN(val){
    return typeof val != 'number';
  }

  tidyHistory(values: number[]) : number[]{
    if (values == null || values.length == 0){
      values = [];
    }
    while (values.length < this.history){
      values.unshift(0);
    }
    while (values.length > this.history){
      values.shift();
    }
    return values;
  }

  widgetDataAdded(s: SharedPoint) {
    
  }

  ngDoCheck() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }



  control(direction, distance){
    if (this.ptzZoom > 20){
      distance = distance / 8;
    }
    else if (this.ptzZoom > 15){
      distance = distance / 6;
    }
    else if (this.ptzZoom > 10){
      distance = distance / 4;
    }
    else if (this.ptzZoom > 5){
      distance = distance / 2;
    }

    if (direction == "right"){
      var dir = this.ptzDirection + distance;
      while (dir > 359){
        dir = dir - 360;
      }
      this.ptzDirection = dir
    }
    if (direction == "left"){
      var dir2 = this.ptzDirection - distance;
      while (dir2 < 0){
        dir2 = dir2 + 360;
      }
      this.ptzDirection = dir2
    }
    if (direction == "up"){
      var zoom = this.ptzElevation + distance;
      this.ptzElevation = Math.min(90, zoom);
    }
    if (direction == "down"){
      var zoomDown = this.ptzElevation - distance;
      this.ptzElevation = Math.max(-90, zoomDown);
    }
    this.executeCameraEvent();
  }

  zoom(direction){
    if (this.ptzZoom == null || this.isNaN(this.ptzZoom)) this.ptzZoom = 0;
    if (this.ptzDirection == null || this.isNaN(this.ptzDirection)) this.ptzDirection = 0;
    if (this.ptzElevation == null || this.isNaN(this.ptzElevation)) this.ptzElevation = 0;

    if (direction == "in"){
      var zoom = this.ptzZoom + 1;
      this.ptzZoom = Math.min(47, zoom);
    }
    if (direction == "out"){
      var zoom = this.ptzZoom - 1;
      this.ptzZoom = Math.max(0, zoom);
    }
    this.executeCameraEvent();
  }

  compass(action){
    this.ptzZoom = 1;
    this.ptzElevation = 0
    if (action == "n"){
      this.ptzDirection = 0;
    }
    if (action == "ne"){
      this.ptzDirection = 45;
    }
    if (action == "e"){
      this.ptzDirection = 90;
    }
    if (action == "se"){
      this.ptzDirection = 135;
    }
    if (action == "s"){
      this.ptzDirection = 180;
    }
    if (action == "sw"){
      this.ptzDirection = 225;
    }
    if (action == "w"){
      this.ptzDirection = 270;
    }
    if (action == "nw"){
      this.ptzDirection = 315;
    }
    this.executeCameraEvent();
  }

  //debounceTimeout: any;

  // Function to debounce any function
  debounceTimer;
  debounce(func, delay) {
    const context = this;
    const args = arguments;
    if (this.debounceTimer != null){
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => func.apply(context, args), delay);
  }

  executeCameraEvent(){
    if (this.ptzZoom == null || this.isNaN(this.ptzZoom)) this.ptzZoom = 0;
    if (this.ptzDirection == null || this.isNaN(this.ptzDirection)) this.ptzDirection = 0;
    if (this.ptzElevation == null || this.isNaN(this.ptzElevation)) this.ptzElevation = 0;
    
    this.ptzDirectionChanged.emit(this.ptzDirection);
    this.ptzElevationChanged.emit(this.ptzElevation);
    this.ptzZoomChanged.emit(this.ptzZoom);
    //this.toasterService.info("PTZ Command Queues");
    
    this.debounce(() => {
      var siteUri = this.siteUri;
      var command = {
        customerId: this.app.customerId,
        command: {
          siteUri: siteUri, 
          action: 'point', 
          parameters: [
            { parameterName:'zoom', parameterValue:this.ptzZoom.toString()},
            { parameterName:'direction', parameterValue:this.ptzDirection.toString()},
            { parameterName:'elevation', parameterValue:this.ptzElevation.toString()}
          ]
        }
      };
      console.log("Issuing a command:", command);
      
      this.fire.RunCommand(command).then(c => {
        this.toasterService.success("PTZ Command Issued");
      }, err => {
        this.toasterService.error("Command Not Issued");
      });
    }, 750);
  }

  loadPtz(){
    var cookieCode = "d" + this.siteUri + "-coordinates";
    if (this.cookieService.check(cookieCode)){
      var coordinatesStr = this.cookieService.get("d" + this.siteUri + "-coordinates");
      if (coordinatesStr) {
        var coordinates = JSON.parse(coordinatesStr);
        this.ptzDirection = coordinates.direction;
        this.ptzElevation = coordinates.elevation;
        this.ptzZoom = coordinates.zoom;
      }
    }
  }

  savePtz(){
    var cookieCode = "d" + this.siteUri + "-coordinates";
    this.cookieService.set(cookieCode, JSON.stringify({
      direction: this.ptzDirection,
      elevation: this.ptzElevation,
      zoom: this.ptzZoom
    }));
  }

  preset(ts, action){ 
    var siteUri = ts.siteUri;
    this.cmd.CommandRunCommand({
      customerId: this.app.customerId,
      command: {
        siteUri: siteUri, 
        action: 'preset', 
        parameters: [
          { parameterName:'action', parameterValue:action}
        ]
      }
    }).subscribe(c => {
      this.ptzCommands = this.ptzCommands + action.charAt(0);
    }, err => {
      this.toasterService.error("Command Not Issued");
    });
  }

  photo(){
    this.executeCameraEvent();
  }

}
